import * as types from "../actionTypes/dashboardActionTypes";
import { SET_AUTH_LOGOUT } from "../actionTypes/loginActionTypes";

const initial = {
  SearchLocList: {},
  CurrencyList: {},
  NationalityList: {},
  CityList: {},
  AgentsList: {}, // TW // need to remove
  AgentUsersList: {}, // TW
  AgentCurrenciesList: {}, // TW
  ActiveAgentsDetailsList: {}, // TW
  getDmcList: {},
  getDmcCitiesList: [],
  getDmcTourTypesList: [],
  getDmcPackagesList: [],
  getDmcPackDetailsList: {},
  zoholayoutdependencyMappings: {},
  zohoLayoutRules: {},
  CreateTicket: {},
  updatePGInvoiceNumberData: {},
  addBookingMailDetails: {},
  LoginURL: {},
  checkPanExistForAgentDetails: {},
  billingInvoice: {},
  ProformasInvoice: {},

  HotelSearch: {
    data: {},
    apiState: "initial",
  },
  ProductSearchTimeExpire: {
    data: false,
    apiState: "fulfilled",
  },
  validateDuplicateBookingData: {
    data: {},
    apiState: "initial",
  },

  AgentInvoice: {},
  AgentInfoFinalizeTransfer: {},
  PriceCalculateOCPC: {},
  PostPriceCalculate: {},
  AgentsByCurrency: {},
  agentsByCurrencyAndInvoiceEntity: {},
  BookingsList: {},
  addTransferToAgentDetails: {},
  AddFinalizeBookings: {},

  SearchHotelsList: {
    data: {},
    apiState: "initial",
  },
  HotelsAddresses: {
    data: {},
    apiState: "initial",
  },
  ExtraDetails: {
    data: [],
    apiState: "initial",
  },
  HotelLevelFilter: {
    data: {},
    apiState: "initial",
  },

  HotelInfo: {
    data: {},
    apiState: "initial",
  },
  HotelRates: {
    data: {},
    apiState: "initial",
  },
  RoomOptionsRates: {
    data: {},
    apiState: "initial",
  },

  SimilarHotels: null,

  GetHotelMultiRoomMeanRate: {},

  Airports: {
    data: {},
    apiState: "initial",
  },

  DropAirports: {
    data: {},
    apiState: "initial",
  },

  Airlines: {
    data: {},
    apiState: "initial",
  },

  Accommodations: {
    data: {},
    apiState: "initial",
  },

  DropAccommodations: {
    data: {},
    apiState: "initial",
  },

  TransferSearchDetails: {
    data: {},
    apiState: "initial",
  },

  DestinationDropdownDetails: {
    data: {},
    apiState: "initial",
  },
  DestinationToDropdownDetails: {
    data: {},
    apiState: "initial",
  },

  DestinationActivityDropdownDetails: {
    data: {},
    apiState: "initial",
  },

  focusMenu: "dashboard",
  callHotelListApi: false,
  callAddressesApi: false,
  callExtraDetailsApi: false,

  // searchKey: null,

  CurrentSuppliers: {
    data: {},
    apiState: "initial",
  },

  activitySuppliers: {
    data: {},
    apiState: "initial",
  },

  CancellationPolicy: {},

  // Booking Process Starts here
  BookingIdDetails: {},
  RecheckPriceDetails: {},
  // BookingConfirmationDetails: {},
  HotelCheckoutDetails: {},
  addPGTransactionDetails: {},
  generateHash512ActionDetails: {},
  AgentProfileDetails: {},
  mailTemplateData: {},
  bookingDrafByTWBidData: {},
  ThresholdLimitAdmin: {},
  currencyConversionRates: {},
  addMailLogData: {},
  addUpdateBookingUploadData: {},
  addUpdateBookingDraft: {},
  getAgentById: {},
  addAgentQuoteData: {},
  featuredHotelsDetails: {},
  validatePANDetails: {},
  activityCancellationPolicyDetails: {},
  transferCancellationPolicyDetails: {},
  abandonReasonsDetails: {},
  bookableThresholdDetails: {},
  bookableCLDetails: {},
  bookableWBDetails: {},
  agentProfileByAgentIdData: {},
  configValueData: {},
  previewURLData: {},
  AgentAllWidgetsData: {},
  addUserSearchHistoryDetails: {},
  itineraryIdByTempIdDetails: {},
  getUserSearchHistoryDetails: {},
  // Booking Process Ends here
  updateValidationStatusDetails: {},
  postPaymentGatewayData: {},
  BookingdetailsByiternaryId: [],
  BookingDetailsByBid: {
    data: {},
    apiState: "started",
  },
  paymentGatewayTransactionsDetails: {},
  PaymentLink: {},
  voucherViewDetailsDetails: {},
  voucherViewEurailDetailsDetails: {},
  voucherViewTransferDetailsDetails: {},
  voucherViewActivityDetails: {},
  biDfromTempIdDetails: {},
  IsDarkMode: false,
  finalizeBookingTransferAdmin: {},
  finalizedBookingTransferAgent: {},
  addTransferToAgentTransfer: {},
  getAccessNotificationsPermissions: {},
  GetRequestFailureReasonStatus: {},
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const DashboardReducer = (state = initial, action: any) => {
  switch (action.type) {
    case types.GET_SEARCH_LOC.FULLFILLED:
      return {
        ...state,
        SearchLocList: { ...state.SearchLocList, ...action.payload },
      };
    case types.GET_SEARCH_LOC.REJECTED:
      return {
        ...state,
        SearchLocList: { data: {} },
      };
    case SET_AUTH_LOGOUT:
      return {
        ...state,
        SearchLocList: {
          data: {},
          apiState: "initial",
        },
      };
    case types.GET_CURRENCY_LIST.FULLFILLED:
      return { ...state, CurrencyList: action.payload };
    case types.GET_NATIONALITY_LIST.FULLFILLED:
      return { ...state, NationalityList: action.payload };
    case types.GET_CITY_LIST.FULLFILLED:
      return { ...state, CityList: action.payload };

    case types.GET_AGENTS_LIST.FULLFILLED:
      return { ...state, AgentsList: action.payload }; // need to remove

    case types.GET_ACTIVE_AGENTS_DETAILS.FULLFILLED:
      return { ...state, ActiveAgentsDetailsList: action.payload };
    case types.GET_ACTIVE_AGENTS_DETAILS.REJECTED:
      return {
        ...state,
        ActiveAgentsDetailsList: { data: {}, apiState: "rejected" },
      };
    case types.GET_AGENTS_USERS_LIST.FULLFILLED:
      return { ...state, AgentUsersList: action.payload };
    case types.GET_CURRENCIES_BY_AGENTID.FULLFILLED:
      return { ...state, AgentCurrenciesList: action.payload };
    case types.GET_AGENT_CREDIT_LIMIT.FULLFILLED:
      return { ...state, AgentProfileDetails: action.payload };
    case types.GET_AGENT_CREDIT_LIMIT.REJECTED:
      return { ...state, AgentProfileDetails: {} };

    case types.GET_MAIL_TEMPLATE.FULLFILLED:
      return { ...state, mailTemplateData: action.payload };
    case types.GET_BOOKINGDRAFT_BY_TWBID.FULLFILLED:
      return { ...state, bookingDrafByTWBidData: action.payload };
    case types.GET_BOOKINGDRAFT_BY_TWBID.REJECTED:
      return {
        ...state,
        bookingDrafByTWBidData: { data: {}, apiState: "rejected" },
      };
    case types.GET_GET_THRESHOLDLIMIT.FULLFILLED:
      return { ...state, ThresholdLimitAdmin: action.payload };
    case types.GET_CURRENCY_CONVERSION_RATES.FULLFILLED:
      return { ...state, currencyConversionRates: action.payload };
    case types.GET_CURRENCY_CONVERSION_RATES.REJECTED:
      return { ...state, currencyConversionRates: {} };
    case types.GET_ADD_MAIL_LOG.FULLFILLED:
      return { ...state, addMailLogData: action.payload };
    case types.GET_ADD_UPDATE_BOOKING_UPLOAD.FULLFILLED:
      return { ...state, addUpdateBookingUploadData: action.payload };
    case types.GET_ADD_UPDATE_BOOKING_DRAFT.FULLFILLED:
      return { ...state, addUpdateBookingDraft: action.payload };
    case types.GET_ADD_UPDATE_BOOKING_DRAFT.REJECTED:
      return { ...state, addUpdateBookingDraft: {} };
    case types.BOOKINGDETAILS_BY_ITERNARYID.FULLFILLED:
      return { ...state, BookingdetailsByiternaryId: action.payload };
    case types.BOOKINGDETAILS_BY_ITERNARYID.REJECTED:
      return { ...state, BookingdetailsByiternaryId: {} };
    case types.GET_ADD_AGENTQUOTE.FULLFILLED:
      return { ...state, addAgentQuoteData: action.payload };
    case types.GET_AGENT_BY_ID.FULLFILLED:
      return { ...state, getAgentById: action.payload };
    case types.PAYMENT_GATEWAY_TRANSACTIONS.FULLFILLED:
      return {
        ...state,
        paymentGatewayTransactionsDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VALIDATE_PAYMENT_LINK.FULLFILLED:
      return {
        ...state,
        PaymentLink: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.PAYMENT_GATEWAY_TRANSACTIONS.REJECTED:
      return {
        ...state,
        paymentGatewayTransactionsDetails: { data: {}, apiState: "rejected" },
      };
    case types.VOUCHER_VIEW_DETAILS.FULLFILLED:
      return {
        ...state,
        voucherViewDetailsDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VOUCHER_VIEW_DETAILS.REJECTED:
      return {
        ...state,
        voucherViewDetailsDetails: { data: {}, apiState: "rejected" },
      };

    case types.VOUCHER_VIEW_EURAIL_DETAILS.FULLFILLED:
      return {
        ...state,
        voucherViewEurailDetailsDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VOUCHER_VIEW_EURAIL_DETAILS.REJECTED:
      return {
        ...state,
        voucherViewEurailDetailsDetails: {
          data: {},
          apiState: "rejected",
        },
      };

    case types.VOUCHER_VIEW_TRANSFER_DETAILS.FULLFILLED:
      return {
        ...state,
        voucherViewTransferDetailsDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VOUCHER_VIEW_TRANSFER_DETAILS.REJECTED:
      return {
        ...state,
        voucherViewTransferDetailsDetails: { data: {}, apiState: "rejected" },
      };

    case types.VOUCHER_VIEW_ACTIVITY_DETAILS.FULLFILLED:
      return {
        ...state,
        voucherViewActivityDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VOUCHER_VIEW_ACTIVITY_DETAILS.REJECTED:
      return {
        ...state,
        voucherViewActivityDetails: { data: {}, apiState: "rejected" },
      };

    case types.BID_FROM_TEMP_ID.FULLFILLED:
      return {
        ...state,
        biDfromTempIdDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.BID_FROM_TEMP_ID.REJECTED:
      return {
        ...state,
        biDfromTempIdDetails: { data: null, apiState: "rejected" },
      };

    // ------------------> GET_HOTEL_SEARCH start
    case types.GET_HOTEL_SEARCH.STARTED:
      return { ...state, HotelSearch: { data: {}, apiState: "started" } };
    case types.GET_HOTEL_SEARCH.FULLFILLED:
      return {
        ...state,
        HotelSearch: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTEL_SEARCH.REJECTED:
      return { ...state, HotelSearch: { data: {}, apiState: "rejected" } };
    case types.RESET_GET_HOTEL_SEARCH:
      return { ...state, HotelSearch: { data: {}, apiState: "initial" } };
    // ------------------> GET_HOTEL_SEARCH end

    // ------------------> SET_PRODUCT_SEARCH_TIME_EXPIRE start
    case types.SET_PRODUCT_SEARCH_TIME_EXPIRE.FULLFILLED:
      return {
        ...state,
        ProductSearchTimeExpire: { data: action.payload, apiState: "fulfilled" },
      };
    // ------------------>  SET_PRODUCT_SEARCH_TIME_EXPIRE end

    // ------------------> VALIDATE_DUPLICATE_BOOKING start
    case types.VALIDATE_DUPLICATE_BOOKING.STARTED:
      return {
        ...state,
        validateDuplicateBookingData: { data: {}, apiState: "started" },
      };
    case types.VALIDATE_DUPLICATE_BOOKING.FULLFILLED:
      return {
        ...state,
        validateDuplicateBookingData: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.VALIDATE_DUPLICATE_BOOKING.REJECTED:
      return {
        ...state,
        validateDuplicateBookingData: { data: {}, apiState: "rejected" },
      };
    // ------------------> VALIDATE_DUPLICATE_BOOKING end

    case types.AGENT_INVOICE_ACTIONTYPE.FULLFILLED:
      return { ...state, AgentInvoice: action.payload };

    case types.AGENT_INFO_FINALIZE_TRANSFER.FULLFILLED:
      return { ...state, AgentInfoFinalizeTransfer: action.payload };
    case types.AGENT_INFO_FINALIZE_TRANSFER.REJECTED:
      return { ...state, AgentInfoFinalizeTransfer: {} };

    case types.PRICE_CALCULATE_OC_PC.FULLFILLED:
      return { ...state, PriceCalculateOCPC: action.payload };
    case types.PRICE_CALCULATE_OC_PC.REJECTED:
      return { ...state, PriceCalculateOCPC: {} };

    case types.POST_PRICE_CALCULATE.FULLFILLED:
      return { ...state, PostPriceCalculate: action.payload };
    case types.POST_PRICE_CALCULATE.REJECTED:
      return { ...state, PostPriceCalculate: {} };

    case types.AGENTS_BY_CURRENCY.FULLFILLED:
      return { ...state, AgentsByCurrency: action.payload };
    case types.AGENTS_BY_CURRENCY.REJECTED:
      return { ...state, AgentsByCurrency: {} };

    case types.AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.FULLFILLED:
      return {
        ...state,
        agentsByCurrencyAndInvoiceEntity: action.payload,
      };
    case types.AGENTS_BY_CURRENCY_AND_INVOICEENTITY_ACTION_TYPE.REJECTED:
      return {
        ...state,
        agentsByCurrencyAndInvoiceEntity: {},
      };

    case types.BOOKINGS_LIST.FULLFILLED:
      return { ...state, BookingsList: action.payload };

    case types.ADD_TRANSFER_TO_AGENT.FULLFILLED:
      return { ...state, addTransferToAgentDetails: action.payload };
    case types.ADD_TRANSFER_TO_AGENT.REJECTED:
      return { ...state, addTransferToAgentDetails: {} };

    case types.ADD_FINALIZE_BOOKINGS.FULLFILLED:
      return { ...state, AddFinalizeBookings: action.payload };
    case types.ADD_FINALIZE_BOOKINGS.REJECTED:
      return { ...state, AddFinalizeBookings: {} };

    // ------------------> GET_HOTELS_LIST start
    case types.GET_HOTELS_LIST.STARTED:
      return { ...state, SearchHotelsList: { data: {}, apiState: "started" } };
    case types.GET_HOTELS_LIST.FULLFILLED:
      return {
        ...state,
        SearchHotelsList: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTELS_LIST.REJECTED:
      return { ...state, SearchHotelsList: { data: {}, apiState: "rejected" } };
    case types.RESET_GET_HOTELS_LIST:
      return { ...state, SearchHotelsList: { data: {}, apiState: "initial" } };
    // ------------------> GET_HOTELS_LIST end

    // ------------------> GET_SEARCH_ADDRESSES start
    case types.GET_SEARCH_ADDRESSES.STARTED:
      return { ...state, HotelsAddresses: { data: {}, apiState: "started" } };
    case types.GET_SEARCH_ADDRESSES.FULLFILLED:
      return {
        ...state,
        HotelsAddresses: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_SEARCH_ADDRESSES.REJECTED:
      return { ...state, HotelsAddresses: { data: {}, apiState: "rejected" } };
    case types.RESET_GET_SEARCH_ADDRESSES:
      return { ...state, HotelsAddresses: { data: {}, apiState: "initial" } };
    // ------------------> GET_SEARCH_ADDRESSES end

    // ------------------> GET_SEARCH_EXTRA_DETAILS start
    case types.GET_SEARCH_EXTRA_DETAILS.STARTED:
      return {
        ...state,
        ExtraDetails: { ...state.ExtraDetails, apiState: "started" },
      };
    case types.GET_SEARCH_EXTRA_DETAILS.FULLFILLED:
      return {
        ...state,
        ExtraDetails: {
          data: action.payload.setCustomImage
            ? action.payload.data
            : [...(state?.ExtraDetails?.data ?? []), ...action.payload],
          apiState: "fulfilled",
        },
      };
    case types.GET_SEARCH_EXTRA_DETAILS.REJECTED:
      return {
        ...state,
        ExtraDetails: { ...state.ExtraDetails, apiState: "rejected" },
      };
    case types.RESET_GET_SEARCH_EXTRA_DETAILS:
      return { ...state, ExtraDetails: { data: [], apiState: "initial" } };
    // ------------------> GET_SEARCH_EXTRA_DETAILS end

    // ------------------> GET_HOTEL_LEVEL_FILTER start
    case types.GET_HOTEL_LEVEL_FILTER.STARTED:
      return { ...state, HotelLevelFilter: { data: {}, apiState: "started" } };
    case types.GET_HOTEL_LEVEL_FILTER.FULLFILLED:
      return {
        ...state,
        HotelLevelFilter: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTEL_LEVEL_FILTER.REJECTED:
      return { ...state, HotelLevelFilter: { data: {}, apiState: "rejected" } };
    case types.RESET_GET_HOTEL_LEVEL_FILTER:
      return { ...state, HotelLevelFilter: { data: {}, apiState: "initial" } };
    // ------------------> GET_HOTEL_LEVEL_FILTER end

    // ------------------> Hotel Details Page Polling start
    case types.RESET_HOTEL_DETAILS: {
      return {
        ...state,
        HotelInfo: { data: {}, apiState: "initial" },
        HotelRates: { data: {}, apiState: "initial" },
        RoomOptionsRates: { data: {}, apiState: "initial" },
      };
    }
    case types.GET_HOTEL_INFO.STARTED:
      return {
        ...state,
        HotelInfo: { data: {}, apiState: "started" },
      };
    case types.GET_HOTEL_INFO.FULLFILLED:
      return {
        ...state,
        HotelInfo: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTEL_INFO.REJECTED:
      return {
        ...state,
        HotelInfo: { data: {}, apiState: "rejected" },
      };

    case types.GET_HOTEL_RATES.STARTED:
      return {
        ...state,
        HotelRates: { data: {}, apiState: "started" },
      };
    case types.GET_HOTEL_RATES.FULLFILLED:
      return {
        ...state,
        HotelRates: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTEL_RATES.REJECTED:
      return {
        ...state,
        HotelRates: { data: {}, apiState: "rejected" },
      };
    case types.GET_SIMILAR_HOTELS.FULLFILLED:
      return {
        ...state,
        SimilarHotels: action.payload || null,
      };
    case types.GET_SIMILAR_HOTELS.RESET:
      return {
        ...state,
        SimilarHotels: null,
        SearchHotelsList: {
          data: {},
          apiState: "initial",
        },
        HotelsAddresses: {
          data: {},
          apiState: "initial",
        },
      };

    case types.GET_HOTEL_RATES_MORE.STARTED:
      return {
        ...state,
        // HotelRates: { ...state.HotelRates, },
      };
    case types.GET_HOTEL_RATES_MORE.FULLFILLED:
      return {
        ...state,
        HotelRates: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_HOTEL_RATES_MORE.REJECTED:
      return {
        ...state,
        HotelRates: { data: {}, apiState: "rejected" },
      };

    case types.GET_ROOM_OPTIONS_RATES.STARTED:
      return {
        ...state,
        RoomOptionsRates: { data: {}, apiState: "started" },
      };
    case types.GET_ROOM_OPTIONS_RATES.FULLFILLED:
      return {
        ...state,
        RoomOptionsRates: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ROOM_OPTIONS_RATES.REJECTED:
      return {
        ...state,
        RoomOptionsRates: { data: {}, apiState: "rejected" },
      };

    case types.GET_ROOM_OPTIONS_RATES_MORE.STARTED:
      return {
        ...state,
        // RoomOptionsRates: { data: {}, apiState: "started" },
      };
    case types.GET_ROOM_OPTIONS_RATES_MORE.FULLFILLED:
      return {
        ...state,
        RoomOptionsRates: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ROOM_OPTIONS_RATES_MORE.REJECTED:
      return {
        ...state,
        RoomOptionsRates: { data: {}, apiState: "rejected" },
      };
    // ------------------> Hotel Details Page Polling end

    // ------------------> GET_HOTEL_MULTIROOM_MEAN_RATE start
    case types.GET_HOTEL_MULTIROOM_MEAN_RATE.FULLFILLED:
      return { ...state, GetHotelMultiRoomMeanRate: action.payload };
    case types.GET_HOTEL_MULTIROOM_MEAN_RATE.REJECTED:
      return { ...state, GetHotelMultiRoomMeanRate: {} };
    // ------------------> GET_HOTEL_MULTIROOM_MEAN_RATE end

    case types.GET_AIRPORTS.FULLFILLED:
      return {
        ...state,
        Airports: { data: action.payload, apiState: "fulfilled" },
      };

    case types.GET_DROP_AIRPORTS.FULLFILLED:
      return {
        ...state,
        DropAirports: { data: action.payload, apiState: "fulfilled" },
      };

    case types.GET_AIRLINES.FULLFILLED:
      return {
        ...state,
        Airlines: { data: action.payload, apiState: "fulfilled" },
      };

    case types.GET_AIRPORTS.RESET:
      return {
        ...state,
        Airports: { data: {}, apiState: "initial" },
      };

    case types.GET_DROP_AIRPORTS.RESET:
      return {
        ...state,
        DropAirports: { data: {}, apiState: "initial" },
      };

    case types.GET_ACCOMMODATION.FULLFILLED:
      return {
        ...state,
        Accommodations: { data: action.payload, apiState: "fulfilled" },
      };

    case types.GET_DROP_ACCOMMODATION.FULLFILLED:
      return {
        ...state,
        DropAccommodations: { data: action.payload, apiState: "fulfilled" },
      };

    case types.GET_DROP_ACCOMMODATION.RESET:
      return {
        ...state,
        DropAccommodations: { data: {}, apiState: "initial" },
      };

    case types.GET_ACCOMMODATION.RESET:
      return {
        ...state,
        Accommodations: { data: {}, apiState: "initial" },
      };

    // ------------------> GET_DESTINATION start
    case types.GET_DESTINATION.STARTED:
      return {
        ...state,
        DestinationDropdownDetails: { data: {}, apiState: "started" },
      };
    case types.GET_DESTINATION.FULLFILLED:
      return {
        ...state,
        DestinationDropdownDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.GET_DESTINATION.REJECTED:
      return {
        ...state,
        DestinationDropdownDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_DESTINATION:
      return {
        ...state,
        DestinationDropdownDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_DESTINATION end

    // ------------------> GET_DESTINATIONTO start
    case types.GET_DESTINATIONTO.STARTED:
      return {
        ...state,
        DestinationToDropdownDetails: { data: {}, apiState: "started" },
      };
    case types.GET_DESTINATIONTO.FULLFILLED:
      return {
        ...state,
        DestinationToDropdownDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.GET_DESTINATIONTO.REJECTED:
      return {
        ...state,
        DestinationToDropdownDetails: { data: {}, apiState: "rejected" },
      };
    case types.GET_DESTINATIONTO.RESET:
      return {
        ...state,
        DestinationToDropdownDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_DESTINATIONTO end

    // ------------------> GET_DESTINATION_ACTIVITY start
    case types.GET_DESTINATION_ACTIVITY.STARTED:
      return {
        ...state,
        DestinationActivityDropdownDetails: { data: {}, apiState: "started" },
      };
    case types.GET_DESTINATION_ACTIVITY.FULLFILLED:
      return {
        ...state,
        DestinationActivityDropdownDetails: {
          data: action.payload,
          apiState: "fulfilled",
        },
      };
    case types.GET_DESTINATION_ACTIVITY.REJECTED:
      return {
        ...state,
        DestinationActivityDropdownDetails: { data: {}, apiState: "rejected" },
      };
    case types.RESET_GET_DESTINATION_ACTIVITY:
      return {
        ...state,
        DestinationActivityDropdownDetails: { data: {}, apiState: "initial" },
      };
    // ------------------> GET_DESTINATION_ACTIVITY end

    // these are used to know whether to call particular apis or not
    case types.SET_CALL_HOTEL_LIST_API:
      return { ...state, callHotelListApi: action.payload };
    case types.SET_CALL_ADDRESSES_API:
      return { ...state, callAddressesApi: action.payload };
    case types.SET_CALL_EXTRA_DETAILS_API:
      return { ...state, callExtraDetailsApi: action.payload };

    case types.SET_SIDE_NAV_BAR_FOCUS:
      return { ...state, focusMenu: action.payload };
    // case types.SEARCHKEY:
    //   return { ...state, searchKey: action.payload };

    //current suppliers starts
    case types.GET_ALL_CURRENT_SUPPLIERS.STARTED:
      return { ...state, CurrentSuppliers: { data: {}, apiState: "started" } };
    case types.GET_ALL_CURRENT_SUPPLIERS.FULLFILLED:
      return {
        ...state,
        CurrentSuppliers: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ALL_CURRENT_SUPPLIERS.REJECTED:
      return { ...state, CurrentSuppliers: { data: {}, apiState: "rejected" } };
    case types.RESET_GET_ALL_CURRENT_SUPPLIERS:
      return { ...state, CurrentSuppliers: { data: {}, apiState: "initial" } };
    //current suppliers ends

    //activity current suppliers starts
    case types.GET_ACTIVITIES_CURRENT_SUPPLIERS.STARTED:
      return { ...state, activitySuppliers: { data: {}, apiState: "started" } };
    case types.GET_ACTIVITIES_CURRENT_SUPPLIERS.FULLFILLED:
      return {
        ...state,
        activitySuppliers: { data: action.payload, apiState: "fulfilled" },
      };
    case types.GET_ACTIVITIES_CURRENT_SUPPLIERS.REJECTED:
      return {
        ...state,
        activitySuppliers: { data: {}, apiState: "rejected" },
      };
    //activity current suppliers ends

    case types.GET_CALL_CANCELLATION_POLICY.FULLFILLED:
      return { ...state, CancellationPolicy: action.payload };
    case types.GET_CALL_CANCELLATION_POLICY.REJECTED:
      return { ...state, CancellationPolicy: {} };

    // Booking Process Starts here
    case types.GET_BOOKNOW_ID.FULLFILLED:
      return { ...state, BookingIdDetails: action.payload };
    case types.GET_RECHECK_PRICE.FULLFILLED:
      return { ...state, RecheckPriceDetails: action.payload };
    // case types.GET_BOOKING_DETAILS.FULLFILLED:
    //   return { ...state, BookingConfirmationDetails: action.payload };
    case types.GET_HOTEL_CHECKOUT_DETAILS.FULLFILLED:
      return { ...state, HotelCheckoutDetails: action.payload };
    case types.GET_HOTEL_CHECKOUT_DETAILS.REJECTED:
      return { ...state, HotelCheckoutDetails: action.payload };
    // Booking Process Ends here

    case types.ADD_PG_TRANSACTION_DETAILS.FULLFILLED:
      return { ...state, addPGTransactionDetails: action.payload };
    case types.ADD_PG_TRANSACTION_DETAILS.REJECTED:
      return { ...state, addPGTransactionDetails: action.payload };

    case types.GENERATE_HASH512_DETAILS.FULLFILLED:
      return { ...state, generateHash512ActionDetails: action.payload };
    case types.GENERATE_HASH512_DETAILS.REJECTED:
      return { ...state, generateHash512ActionDetails: action.payload };

    case types.VALIDATE_PAN_DETAILS.FULLFILLED:
      return { ...state, validatePANDetails: action.payload };
    case types.VALIDATE_PAN_DETAILS.REJECTED:
      return { ...state, validatePANDetails: action.payload };

    case types.ACTIVITY_CANCELLATION_POLICY_DETAILS.FULLFILLED:
      return { ...state, activityCancellationPolicyDetails: action.payload };
    case types.ACTIVITY_CANCELLATION_POLICY_DETAILS.REJECTED:
      return { ...state, activityCancellationPolicyDetails: action.payload };

    case types.TRANSFER_CANCELLATION_POLICY_DETAILS.FULLFILLED:
      return { ...state, transferCancellationPolicyDetails: action.payload };
    case types.TRANSFER_CANCELLATION_POLICY_DETAILS.REJECTED:
      return { ...state, transferCancellationPolicyDetails: action.payload };

    case types.ABANDON_REASONS_DETAILS.FULLFILLED:
      return { ...state, abandonReasonsDetails: action.payload };
    case types.ABANDON_REASONS_DETAILS.REJECTED:
      return { ...state, abandonReasonsDetails: action.payload };

    case types.BOOKABLE_THRESHOLD_DETAILS.FULLFILLED:
      return { ...state, bookableThresholdDetails: action.payload };
    case types.BOOKABLE_THRESHOLD_DETAILS.REJECTED:
      return { ...state, bookableThresholdDetails: {} };

    case types.BOOKABLE_CL_DETAILS.FULLFILLED:
      return { ...state, bookableCLDetails: action.payload };
    case types.BOOKABLE_CL_DETAILS.REJECTED:
      return { ...state, bookableCLDetails: {} };

    case types.BOOKABLE_WB_DETAILS.FULLFILLED:
      return { ...state, bookableWBDetails: action.payload };
    case types.BOOKABLE_WB_DETAILS.REJECTED:
      return { ...state, bookableWBDetails: {} };

    case types.GET_AGENT_PROFILE_BY_AGENTID.FULLFILLED:
      return { ...state, agentProfileByAgentIdData: action.payload };
    case types.GET_AGENT_PROFILE_BY_AGENTID.REJECTED:
      return { ...state, agentProfileByAgentIdData: action.payload };

    case types.CONFIG_VALUE.FULLFILLED:
      return { ...state, configValueData: action.payload };
    case types.CONFIG_VALUE.REJECTED:
      return { ...state, configValueData: action.payload };

    case types.PREVIEW_URL.FULLFILLED:
      return { ...state, previewURLData: action.payload };
    case types.PREVIEW_URL.REJECTED:
      return { ...state, previewURLData: action.payload };

    case types.AGENT_ALL_WIDGETS_DATA.FULLFILLED:
      return { ...state, AgentAllWidgetsData: action.payload };
    case types.AGENT_ALL_WIDGETS_DATA.REJECTED:
      return { ...state, AgentAllWidgetsData: action.payload };

    case types.GET_ADD_USER_SEARCH_HISTORY.FULLFILLED:
      return { ...state, addUserSearchHistoryDetails: action.payload };
    case types.GET_ADD_USER_SEARCH_HISTORY.REJECTED:
      return { ...state, addUserSearchHistoryDetails: action.payload };

    case types.ITINERARY_ID_BY_TEMPID.FULLFILLED:
      return { ...state, itineraryIdByTempIdDetails: action.payload };
    case types.ITINERARY_ID_BY_TEMPID.REJECTED:
      return { ...state, itineraryIdByTempIdDetails: action.payload };

    case types.POST_PAYMENT_GATEWAY.FULLFILLED:
      return { ...state, postPaymentGatewayData: action.payload };
    case types.POST_PAYMENT_GATEWAY.REJECTED:
      return { ...state, postPaymentGatewayData: action.payload };

    case types.GET_GET_USER_SEARCH_HISTORY.FULLFILLED:
      return { ...state, getUserSearchHistoryDetails: action.payload };
    case types.GET_GET_USER_SEARCH_HISTORY.REJECTED:
      return { ...state, getUserSearchHistoryDetails: {} };

    case types.UPDATE_VALIDATION_STATUS_DETAILS.FULLFILLED:
      return { ...state, updateValidationStatusDetails: action.payload };
    case types.UPDATE_VALIDATION_STATUS_DETAILS.REJECTED:
      return { ...state, updateValidationStatusDetails: action.payload };

    case types.GENERATE_FEATURED_HOTELS_DETAILS.FULLFILLED:
      return { ...state, featuredHotelsDetails: action.payload };
    case types.GENERATE_FEATURED_HOTELS_DETAILS.REJECTED:
      return { ...state, featuredHotelsDetails: action.payload };

    case types.GET_BOOKING_DETAILS_BYBID.FULLFILLED:
      return { ...state, BookingDetailsByBid: action.payload };

    case types.SET_DARK_THEME:
      return { ...state, IsDarkMode: action.payload };

    case types.GET_DMC_LIST.FULLFILLED:
      return {
        ...state,
        getDmcList: action.payload,
      };

    case types.GET_DMC_CITIES_LIST.FULLFILLED:
      return {
        ...state,
        getDmcCitiesList: action.payload,
      };
    case types.GET_DMC_TOURTYPES_LIST.FULLFILLED:
      return { ...state, getDmcTourTypesList: action.payload };
    case types.GET_DMC_PACKAGES_LIST.FULLFILLED:
      return {
        ...state,
        getDmcPackagesList: action.payload,
      };
    case types.GET_DMC_PACKAGES_DETAILS_LIST.FULLFILLED:
      return {
        ...state,
        getDmcPackDetailsList: action.payload,
      };
    case types.SET_ZOHO_LAYOUT_RULES.FULLFILLED:
      return { ...state, zohoLayoutRules: action.payload };
    case types.SET_ZOHO_TICKET_DEPENDENCY_MAPPING.FULLFILLED:
      return { ...state, zoholayoutdependencyMappings: action.payload };
    // case types.ADD_CONTACT_US_INFO_LIST.FULLFILLED:
    //   return{...state,addContactUsInfo:action.payload};
    case types.SET_ZOHO_TICKET_CREATION.FULLFILLED:
      return { ...state, CreateTicket: action.payload };

    case types.UPDATE_PG_INVOICE_NUMBER.FULLFILLED:
      return { ...state, updatePGInvoiceNumberData: action.payload };
    case types.UPDATE_PG_INVOICE_NUMBER.REJECTED:
      return { ...state, updatePGInvoiceNumberData: action.payload };

    case types.ADD_BOOKING_MAIL_DATA.FULLFILLED:
      return { ...state, addBookingMailDetails: action.payload };
    case types.ADD_BOOKING_MAIL_DATA.REJECTED:
      return { ...state, addBookingMailDetails: action.payload };

    case types.GENERATE_LOGINURL_DETAILS.FULLFILLED:
      return { ...state, LoginURL: action.payload };
    case types.GENERATE_LOGINURL_DETAILS.REJECTED:
      return { ...state, LoginURL: action.payload };

    case types.CHECK_PAN_EXISTS_FOR_AGENT_DATA.FULLFILLED:
      return { ...state, checkPanExistForAgentDetails: action.payload };
    case types.CHECK_PAN_EXISTS_FOR_AGENT_DATA.REJECTED:
      return { ...state, checkPanExistForAgentDetails: action.payload };

    case types.GRN_INVOICES_ACTIONTYPE.FULLFILLED:
      return { ...state, billingInvoice: action.payload };
    case types.GRN_PROFORMAS_ACTIONTYPE.FULLFILLED:
      return { ...state, ProformasInvoice: action.payload };
    case types.ADD_DUPLICATE_BOOKING_MAIL_DATA.FULLFILLED:
      return { ...state, addDuplicateBookingMailData: action.payload };
    case types.ADD_DUPLICATE_BOOKING_MAIL_DATA.REJECTED:
      return { ...state, addDuplicateBookingMailData: action.payload };

    case types.FINALIZE_BOOKINGS_TRANSFER_ADMIN.FULLFILLED:
      return { ...state, finalizeBookingTransferAdmin: action.payload };
    case types.FINALIZE_BOOKINGS_TRANSFER_ADMIN.REJECTED:
      return { ...state, finalizeBookingTransferAdmin: {} };
    case types.FINALIZED_BOOKINGS_TRANSFER_AGENT.FULLFILLED:
      return { ...state, finalizedBookingTransferAgent: action.payload };
    case types.FINALIZED_BOOKINGS_TRANSFER_AGENT.REJECTED:
      return { ...state, finalizedBookingTransferAgent: {} };
    case types.ADD_TRANSFER_TO_AGENT_TRANSFER.FULLFILLED:
      return { ...state, addTransferToAgentTransfer: action.payload };
    case types.ADD_TRANSFER_TO_AGENT_TRANSFER.REJECTED:
      return { ...state, addTransferToAgentTransfer: {} };

    case types.ACCESS_NOTIFICATIONS.FULLFILLED:
      return { ...state, getAccessNotificationsPermissions: action.payload };
    case types.ACCESS_NOTIFICATIONS.REJECTED:
      return { ...state, getAccessNotificationsPermissions: action.payload };
    case types.REQUEST_FAILURE_REASON_STATUS.FULLFILLED:
      return { ...state, GetRequestFailureReasonStatus: action.payload };
    case types.REQUEST_FAILURE_REASON_STATUS.REJECTED:
      return { ...state, GetRequestFailureReasonStatus: {} };

    default:
      return state;
  }
};

export default DashboardReducer;
